import React, { useCallback } from 'react';
import { useTranslations } from 'js/hooks/i18n';

import * as Types from './types';

export const useRenderErrorMessage: Types.IUseRenderErrorMessage = ({
    updateFieldValue
}) => {
    const translate = useTranslations();
    const error = translate('playtech.mobile.system.form.username.internal.usernameIsInUse');

    return useCallback<Types.IUseRenderErrorMessageCallback>((
        suggestions
    ) => {
        if (suggestions.length > 0) {
            return (
                <>
                    {error}
                    {' '}
                    {suggestions.map((suggestion, index) => (
                        <>
                            {index > 0 && ', '}
                            <a key={index} onClick={() => updateFieldValue(suggestion)}>{suggestion}</a>
                        </>
                    ))}
                    {'.'}
                </>
            );
        }

        return error;
    }, [error, updateFieldValue]);
};
